var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 0.309063V1.6424H8.99992V0.309063H10.3333V1.6424H12.9999C13.3681 1.6424 13.6666 1.94088 13.6666 2.30906V12.9757C13.6666 13.3439 13.3681 13.6424 12.9999 13.6424H0.999919C0.631732 13.6424 0.333252 13.3439 0.333252 12.9757V2.30906C0.333252 1.94088 0.631732 1.6424 0.999919 1.6424H3.66658V0.309063H4.99992ZM12.3333 6.30906H1.66659V12.3091H12.3333V6.30906ZM9.02358 7.0664L9.96638 8.00926L6.66658 11.3091L4.30957 8.95206L5.25237 8.00926L6.66658 9.42346L9.02358 7.0664ZM3.66658 2.97573H1.66659V4.97573H12.3333V2.97573H10.3333V3.6424H8.99992V2.97573H4.99992V3.6424H3.66658V2.97573Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.eef0560bddae4657451fde7b03789cbb.svg";
export { ForwardRef as ReactComponent };